export const StatusIndicator = ({isActive, show}) => {
	if (show === undefined || !show) {
		return null
	}

	const detailOpenerContent = isActive ? '-' : '+';

	return (
		<div className={`status-indicator`}>
			<span>{detailOpenerContent}</span>
		</div>
	)
}
